export type ManageInvoiceDetailVariables = {
  input: {
    chamberId: string;
    invoiceId: string;
  };
};

export const getManageInvoiceDetailVariables = ({
  chamberId,
  invoiceId,
}: {
  chamberId?: string | null;
  invoiceId?: string | null;
}): ManageInvoiceDetailVariables | null => {
  const normalizedChamberId = chamberId?.trim() || "";
  const normalizedInvoiceId = invoiceId?.trim() || "";

  if (!normalizedChamberId || !normalizedInvoiceId) {
    return null;
  }

  return {
    input: {
      chamberId: normalizedChamberId,
      invoiceId: normalizedInvoiceId,
    },
  };
};
